<template>
  <tr>
    <th class="w-8"></th>
    <th class="w-16 pr-0!">
      <RfFilter
        hideIcon
        tableStyle
        activator="Status"
        :groups="{ statuses: { el: StatusesConstants, key: 'type', value: 'title' } }"
        explicit
        :selected="filters"
        @selected="items => emit('update:filters', { ...filters, ...items })"
      />
    </th>
    <th class="min-w-96">
      <RfFilter
        hideIcon
        tableStyle
        class="rf-header--guide-type [&.rf-menu]:justify-start [&.rf-menu_.rf-menu--button]:relative [&.rf-menu_.rf-menu--button]:left-1.5 [&.rf-menu_.rf-menu--button]:ml-36"
        activator="Guide type / creator"
        :groups="{
          sequence_type: { el: GUIDE_TYPES, key: 'value', value: 'label', name: 'Guide type' },
          creator_ids: {
            el: users,
            key: 'id',
            value: getUserName,
            name: 'Creator',
          },
        }"
        explicit
        :selected="filters"
        @selected="items => emit('update:filters', { ...filters, ...items })"
      />
    </th>
    <th class="4xl:w-40 w-24 text-left">
      <RfFilter
        hideIcon
        tableStyle
        class="rf-header--segments grow-0 [&.rf-menu]:justify-start [&.rf-menu_.rf-menu--button]:relative [&.rf-menu_.rf-menu--button]:ml-0.5"
        activator="Segments"
        explicit
        :groups="{ segments: { el: segments, key: 'id', value: 'name' } }"
        :selected="filters"
        @selected="items => $emit('update:filters', { ...filters, ...items })"
      />
    </th>
    <th v-if="engagementCategoriesEnabled" class="4xl:w-32 w-24 text-left">
      <RfFilter
        hideIcon
        tableStyle
        class="grow-0"
        activator="Engagement Category"
        explicit
        :groups="{
          engagement_category: {
            el: engagementCategories,
            key: 'value',
            value: 'label',
          },
        }"
        :selected="filters"
        @selected="items => emit('update:filters', { ...filters, ...items })"
      >
        <template #item="{ el }">
          <RfColorTag
            v-if="el.key"
            :backgroundColor="getCategoryColor(el.key)"
            :title="getCategoryLabel(el.key)"
            pill
            disabled
            class="p-0! *:py-1!"
          />
          <span v-else class="text-body text-beige-50">None</span>
        </template>
      </RfFilter>
    </th>
    <th class="4xl:w-32 w-20">
      <RfSortButton
        :filtered="sort.type === 'start_date' ? sort.value : null"
        class="h-full w-full justify-start"
        data-cy="filters--guide-start"
        @click="value => $emit('update:sort', { type: 'start_date', value })"
      >
        Start
      </RfSortButton>
    </th>
    <th class="4xl:w-32 w-20">
      <RfSortButton
        :filtered="sort.type === 'end_date' ? sort.value : null"
        class="h-full w-full justify-start"
        data-cy="filters--guide-finish"
        @click="value => emit('update:sort', { type: 'end_date', value })"
      >
        Finish
      </RfSortButton>
    </th>

    <th class="bg-goal 4xl:w-32 w-24">
      <RfSortButton
        :filtered="sort.type === 'users' ? sort.value : null"
        class="h-full w-full"
        disabled
        @click="value => emit('update:sort', { type: 'users', value })"
      >
        Users
      </RfSortButton>
    </th>

    <th class="bg-goal 4xl:w-32 w-24">
      <RfSortButton
        :filtered="sort.type === 'goal' ? sort.value : null"
        disabled
        @click="value => emit('update:sort', { type: 'goal', value })"
      >
        Goal
      </RfSortButton>
    </th>
    <th class="bg-goal 4xl:w-32 w-28">
      <RfSortButton
        :filtered="sort.type === 'conversion' ? sort.value : null"
        disabled
        @click="value => emit('update:sort', { type: 'conversion', value })"
      >
        Conversion
      </RfSortButton>
    </th>
    <th class="w-10"></th>
  </tr>
</template>

<script setup>
import StatusesConstants from "@/utils/constants/PromptStatusesConstants";
import { GUIDE_TYPES } from "@/utils/constants/GuidesConstants";
import RfSortButton from "@/components/buttons/RfSortButton.vue";
import RfFilter from "@/components/inputs/RfFilter.vue";
import RfColorTag from "@/components/tags/RfColorTag.vue";
import { getUserName } from "@/utils/stringHelpers";
import { getCategoryColor, getCategoryLabel } from "@/utils/constants/EngagementCategoryConstants";

const emit = defineEmits(["update:filters", "update:sort"]);

defineProps({
  filters: { type: Object, default: null },
  sort: { type: Object, default: null },
  segments: { type: Array, default: () => [] },
  users: { type: Array, default: () => [] },
  engagementCategories: { type: Array, default: () => [] },
  engagementCategoriesEnabled: { type: Boolean, default: false },
});
</script>
